import { render, staticRenderFns } from "./PopupRelease.vue?vue&type=template&id=4ebac202"
import script from "./PopupRelease.vue?vue&type=script&lang=js"
export * from "./PopupRelease.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports